import ComicCard from '@/components/base/ComicCard';
import { getLatestComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = getLatestComics(8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚刚更新的韩漫章节，快来追更</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="medium" />
          ))}
        </div>
      </div>
    </section>
  );
}